<lib-header-switch-profile data-test-id="synlab-header-switch-profile" [links]="(links$ | async) ?? []"
  [user]="(user$ | async) || undefined" [disableLinks]="disableLinks" (onLogout)="logout()"
  [myAccountLink]="myAccountLink$|async" [brandLogoLink]="brandLogoLink$|async">
</lib-header-switch-profile>
